import { useEffect, useState } from 'react'

export const useTextinput = (defaultValue = '') => {
    const [value, setValue] = useState('')

    useEffect(() => { setValue(defaultValue) }, [])

    const onChange = (event) => { setValue(event.target.value) }
    const onReset = () => { setValue('') }

    return { value, onChange, onReset }
}